export const TRANSFORM = 'transform'

export function fmtTranslate(x, y, z) {
  if (arguments.length === 3) {
    return fmtTranslateXYZ(x, y, z)
  } else {
    return fmtTranslateXY(x, y)
  }
}

export function fmtTranslateX(x) {
  return `translateX(${x}px)`
}

export function fmtTranslateY(y) {
  return `translateY(${y}px)`
}

export function fmtTranslateXY(x, y) {
  return `translate(${x}px, ${y}px)`
}

export function fmtTranslateXYZ(x, y, z) {
  return `translate(${x}px, ${y}px) translateZ(${z}px)`
}
